import { requestService } from 'shared/utils/services/requestService';
import { v4 as uuidv4 } from 'uuid';

export const getPubNubAuthToken = async () => {
  return requestService({
    url: `/web-api/pub-nub/auth-token`,
    method: 'GET',
  });
};

export const getPublicToken = async () => {
  let token = sessionStorage.getItem('PUBLIC_SESSION_ID');
  if (!token) {
    token = uuidv4();
    sessionStorage.setItem('PUBLIC_SESSION_ID', token);
  }
  return requestService({
    url: `/web-api/pub-nub/client-auth-token`,
    method: 'POST',
    data: JSON.stringify({
      id: token,
    }),
  });
};
